import React from "react";
import { t } from "i18next";
// import baseapk from "../assets/base.apk";
const DownloadBar = ({ onClose }) => {
  return (
    <div
      _ngcontent-serverapp-c2215114555
      className="pwa-download ng-tns-c2215114555-3 ng-trigger ng-trigger-popWrapTriggerAni ng-star-inserted"
      style={{ display: "block" }}
    >
      <div
        _ngcontent-serverapp-c2215114555
        className="pwa-download-bg ng-tns-c2215114555-3"
      >
        <div
          _ngcontent-serverapp-c2215114555
          className="pwa-texture ng-tns-c2215114555-3"
          style={{
            "background-image":
              'url("/assets/NewIcon/pwa-texture.webp?v=1776751585885")',
          }}
        />
        <div
          _ngcontent-serverapp-c2215114555
          className="pwa-download-container ng-tns-c2215114555-3"
        >
          <span
            onClick={() => {
              onClose(false);
              localStorage.setItem("downloadBar", "false");
            }}
            _ngcontent-serverapp-c2215114555
            className="pwa-close-btn ng-tns-c2215114555-3"
            style={{
              "mask-image":
                'url("/assets/NewIcon/icon-cross-type04.svg?v=1776751585885")',
            }}
          />
          <div
            _ngcontent-serverapp-c2215114555
            className="pwa-hot ng-tns-c2215114555-3"
            style={{
              "background-image":
                'url("/assets/NewIcon/pwa-hot-icon.webp?v=1776751585885")',
            }}
          />
          <div
            _ngcontent-serverapp-c2215114555
            className="pwa-icon-frame ng-tns-c2215114555-3"
          >
            <div
              _ngcontent-serverapp-c2215114555
              className="pwa-icon ng-tns-c2215114555-3"
            >
              <img
                _ngcontent-serverapp-c2215114555
                alt="pwa-icon"
                className="ng-tns-c2215114555-3"
                src="/assets/Other/logo.png"
                loading="lazy"
              />
            </div>
          </div>
          <div
            _ngcontent-serverapp-c2215114555
            className="pwa-content ng-tns-c2215114555-3"
          >
            <p
              _ngcontent-serverapp-c2215114555
              className="pwa-name ng-tns-c2215114555-3"
            >
              nayalodis Web App
            </p>
            <img
              _ngcontent-serverapp-c2215114555
              alt="start"
              className="start ng-tns-c2215114555-3 ng-star-inserted"
              src="/assets/NewIcon/start.svg?v=1776751585885&source=mcdsrc"
              loading="lazy"
              style={{}}
            />
            <img
              _ngcontent-serverapp-c2215114555
              alt="start"
              className="start ng-tns-c2215114555-3 ng-star-inserted"
              src="/assets/NewIcon/start.svg?v=1776751585885&source=mcdsrc"
              loading="lazy"
              style={{}}
            />
            <img
              _ngcontent-serverapp-c2215114555
              alt="start"
              className="start ng-tns-c2215114555-3 ng-star-inserted"
              src="/assets/NewIcon/start.svg?v=1776751585885&source=mcdsrc"
              loading="lazy"
              style={{}}
            />
            <img
              _ngcontent-serverapp-c2215114555
              alt="start"
              className="start ng-tns-c2215114555-3 ng-star-inserted"
              src="/assets/NewIcon/start.svg?v=1776751585885&source=mcdsrc"
              loading="lazy"
              style={{}}
            />
            <img
              _ngcontent-serverapp-c2215114555
              alt="start"
              className="start ng-tns-c2215114555-3 ng-star-inserted"
              src="/assets/NewIcon/start.svg?v=1776751585885&source=mcdsrc"
              loading="lazy"
              style={{}}
            />
            {/**/}
          </div>
          <div
            _ngcontent-serverapp-c2215114555
            className="button btn-primary download-btn ng-tns-c2215114555-3"
          >
            <p
              _ngcontent-serverapp-c2215114555
              className="ng-tns-c2215114555-3"
            >
              <a href={""} download="nayalodis" target="_blank">
                {t("Download")}
              </a>
              
            </p>
          </div>
        </div>
      </div>
      {/**/}
    </div>
  );
};

export default DownloadBar;
